import React, { useRef, useState } from "react";
import {
  ArrowDownCircleIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetOfficeHours from "./hooks/useGetOfficeHours";
import DownloadButton from "../../../../components/DownloadButton";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

//import useGetDigitalAssetsReport from "./hooks/useGetDigitalAssetsReport";

interface OfficeHoursReportProps {}
export const OfficeHoursReport: React.FC<OfficeHoursReportProps> = () => {
  const [exportData, setExportData] = useState([]);
  const { data: officeHours, isLoading: officeHoursLoading } =
    useGetOfficeHours();
  const tableRef = useRef<any>([]);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);

  interface IOfficeHours {
    officeType: string;
    salesTypeC: string;
    channelC: string;
    officeName: string;
    officeCode: string;
    storeNumber: string;
    officeStatus: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    brandMarketingName: string;
    sundayStoreHours: string;
    mondayStoreHours: string;
    tuesdayStoreHours: string;
    wednesdayStoreHours: string;
    thursdayStoreHours: string;
    fridayStoreHours: string;
    saturdayStoreHours: string;
  }

  //For downloading table data
  const mapDataToExport = (data) => {
    setExportData(
      data?.map((ohrs: IOfficeHours) => {
        return {
          Type: ohrs.officeType,
          "Sales Type": ohrs.salesTypeC,
          Channel: ohrs.channelC,
          "Office Name": ohrs.officeName,
          "Office Code": ohrs.officeCode,
          "Corporate Office #": ohrs.storeNumber,
          "Office Status": ohrs.officeStatus,
          Street: ohrs.address,
          City: ohrs.city,
          State: ohrs.state,
          "Zip Code": ohrs.zipCode,
          Brand: ohrs.brandMarketingName,
          "Sunday Office Hours": ohrs.sundayStoreHours,
          "Monday Office Hours": ohrs.mondayStoreHours,
          "Tuesday Office Hours": ohrs.tuesdayStoreHours,
          "Wednesday Office Hours": ohrs.wednesdayStoreHours,
          "Thursday Office Hours": ohrs.thursdayStoreHours,
          "Friday Office Hours": ohrs.fridayStoreHours,
          "Saturday Office Hours": ohrs.saturdayStoreHours,
        };
      })
    );
  };

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "OfficeHoursReport_" + dateTimeToday + ".csv",
    data: exportData,
  };
  const officeColumns = [
    { title: "Type", field: "officeType" },
    { title: "Sales Type", field: "salesTypeC" },
    { title: "Channel", field: "channelC" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "OfficeHourReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Office Code", field: "officeCode" },
    { title: "Corporate Office #", field: "storeNumber" },
    { title: "Office Status", field: "officeStatus" },
    { title: "Street", field: "address" },
    { title: "City", field: "city" },
    { title: "State", field: "state" },
    { title: "Zip Code", field: "zipCode" },
    { title: "Brand", field: "brandMarketingName" },
    { title: "Sunday Office Hours", field: "sundayStoreHours" },
    { title: "Monday Office Hours", field: "mondayStoreHours" },
    { title: "Tuesday Office Hours", field: "tuesdayStoreHours" },
    { title: "Wednesday Office Hours", field: "wednesdayStoreHours" },
    { title: "Thursday Office Hours", field: "thursdayStoreHours" },
    { title: "Friday Office Hours", field: "fridayStoreHours" },
    { title: "Saturday Office Hours", field: "saturdayStoreHours" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Accounts
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Office Hours Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {
                  officeHours?.filter((x) =>
                    user?.isFranchise && user?.isNonFranchise
                      ? true
                      : user?.isFranchise
                      ? x.officeType?.toLowerCase() === "franchise"
                      : x.officeType?.toLowerCase() !== "franchise"
                  ).length
                }
              </span>
            </div>
            <CSVLink className="" {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() =>
                  mapDataToExport(tableRef.current.dataManager.searchedData)
                }
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={officeHours?.filter((x) =>
              user?.isFranchise && user?.isNonFranchise
                ? true
                : user?.isFranchise
                ? x.officeType?.toLowerCase() === "franchise"
                : x.officeType?.toLowerCase() !== "franchise"
            )}
            isLoading={officeHoursLoading}
            columns={officeColumns}
            showTitle={false}
            showToolbar={true}
            toolbarSearch={true}
            searchFieldAlignment="left"
            tableRef={tableRef}
          />
        </div>
      </div>
    </div>
  );
};
